const state = {
  innerPageImages: {},
  /**
   * mp3PlayColor: 播放动画颜色
   * mp3Play:音频播放中图标
   * mp3Stop: 音频已暂停图标
   */
  mp3Play: {},
  detailColors: {},
}

const mutations = {
  SET_INNER_PAGE_IMAGES: (state, val) => {
    state.innerPageImages = val
  },
  SET_MP3_PLAY: (state, val) => {
    state.mp3Play = val
  },
  SET_COLORS: (state, val) => {
    state.detailColors = val
  },
}

const actions = {
  setInnerPageImages ({ commit }, val) {
    commit('SET_INNER_PAGE_IMAGES', val)
  },
  setMp3Play ({ commit }, val) {
    commit('SET_MP3_PLAY', val)
  },
  setColors ({ commit }, val) {
    commit('SET_COLORS', val)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
